//src/components/maps/MapTab.js
import React from 'react';
import {
  NavLink,
  useLocation,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  canManageRouteTemplates,
} from '../../lib/routePermissions';

const MapTabs = () => {
  const { t } = useTranslation("map");
  const location = useLocation();

  const hasRouteTemplateAccess =
    canManageRouteTemplates();

  const activeView =
    location.pathname.includes(
      '/map/routes'
    )
      ? 'routes'
      : 'live';

  return (
    <nav
      className={[
        'map-tabs',
        !hasRouteTemplateAccess
          ? 'map-tabs--single'
          : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-label={t('map.tabs.navigation', {
        defaultValue: 'Navegação do mapa',
      })}
    >
      <span
        className="map-tabs__slider"
        data-view={activeView}
        aria-hidden="true"
      />

      <NavLink
        to="/map/live"
        className={({ isActive }) =>
          `map-tabs__item${isActive ? ' map-tabs__item--active' : ''}`
        }
      >
        {t('map.tabs.liveTransports', {
          defaultValue: 'Transportes atuais',
        })}
      </NavLink>

      {hasRouteTemplateAccess && (
        <NavLink
          to="/map/routes"
          className={({ isActive }) =>
            `map-tabs__item${isActive ? ' map-tabs__item--active' : ''}`
          }
        >
          {t('map.tabs.routes', {
            defaultValue: 'Rotas',
          })}
        </NavLink>
      )}
    </nav>
  );
};

export default MapTabs;